import React, { useState } from "react";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import DashboardLeftMenu from "../DashboardLeftMenu";
import DashboardHeader from "../../Header/DashboardHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEye, faSearch } from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker";
import { NODE_HOST_URL, NODE_HOST_URL_v1 } from "../api/Api";
import Axios from "../../../axios/Axios";
import Spining from "../../UI/Spining/Spining";
import { handleUserLog } from "../../Utils/Utils";

const QuickReply = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const username = lStorage?.user?.username
  const date = new Date();

  const [error, setError] = useState({
    errorStatus: false,
    errorMessage: "",
    bgColor: "",
  });
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(date);
  const [channel, setChannel] = useState("");
  const [urlDataReport, setUrlDataReport] = useState([]);
  const [submitVia, setSubmitVia] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [disable, setDisable] = useState(false)
  const [searchData, setSearchData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const LIMIT = 10;

  // console.log(urlDataReport);

  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
  };

  const onChange = (e) => {
    setChannel(e.target.value);
    setError({ errorStatus: false });
    setUrlDataReport([]);
    setCurrentPage(1);
    setTotalPages(1);
    setTotalRecords(0);
  };

  const isValid = () => {
    if (!channel) {
      setError({
        errorStatus: true,
        errorMessage: "Please Select Channel",
        bgColor: "alert alert-danger",
      });
      return false;
    }

    // Only check submitVia if channel is "whatsapp"
    if (channel === "whatsapp" && !submitVia) {
      setError({
        errorStatus: true,
        errorMessage: "Please Select Submit Via",
        bgColor: "alert alert-danger",
      });
      return false;
    }

    // If all checks pass
    return true;
  };


  const currentDate = (currentDate) => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const urlDetails = async () => {
    if (isValid()) {
      const formattedStartDate = currentDate(startDate);
      const formattedEndDate = currentDate(endDate);
      // setDisable(true)

      const paramData = {
        user_id: userId,
        token: userToken,
        fromdate: formattedStartDate,
        todate: formattedEndDate,
        submit_via: submitVia,
        method: "click_report_summary"
      };

      try {
        let { data } = await Axios.post(`${NODE_HOST_URL_v1}/click_report_summary`, paramData);
        if (data.success) {
          // console.log(data.data);
          setUrlDataReport(data.data);

          // const filterData = Array.from(data.data).map(item => ({
          //   date: item._id.date,
          //   total_count: item._id.total_count,
          // }));
          // if (submitVia === 'api') {
          //   setUrlDataReport(filterData);
          // }
          // else {

          // }
          setDisable(false)

        }
        else {
          setError({
            errorStatus: true,
            errorMessage: data.message,
            bgColor: "alert alert-danger",
          });
          setDisable(false)
        }
      } catch (error) {
        setError({
          errorStatus: true,
          errorMessage: error?.response?.data?.message,
          bgColor: "alert alert-danger",
        });
        setDisable(false)
      }
    }
  };

  const RcsCtaReport = async (page = 1) => {
    setDisable(true);

    const payload = {
      user_id: userId,
      method: "rcsReport",
      fromDate: currentDate(startDate),
      toDate: currentDate(endDate),
      username: username,
      page: page,
      limit: LIMIT,
    };

    try {
      const { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/rcsClickReport`,
        payload,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );

      if (data.success) {
        setUrlDataReport(data.data);
        setCurrentPage(page); // ✅ Set AFTER success, not before

        const total = data.totalRecords || data.total || 0;
        setTotalRecords(total);
        setTotalPages(Math.ceil(total / LIMIT));
        setDisable(false);
      } else {
        setError({
          errorStatus: true,
          errorMessage: data.message,
          bgColor: "alert alert-danger",
        });
        setDisable(false);
      }
    } catch (error) {
      setError({
        errorStatus: true,
        errorMessage: error?.response?.data?.message,
        bgColor: "alert alert-danger",
      });
      setDisable(false);
    }
  };


  const EmailCtaReport = async () => {
    let payload = {
      user_id: userId,
      method: "EmailReport",
      fromdate: currentDate(startDate),
      todate: currentDate(endDate)
    }
    try {
      const { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/EmailReport`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${userToken}` // ✅ Correct
          }
        }
      );
      if (data.success) {
        setUrlDataReport(data.data)
        setDisable(false)
      }
      else {
        setError({
          errorStatus: true,
          errorMessage: data.message,
          bgColor: "alert alert-danger",
        });
        setDisable(false)
      }
    } catch (error) {
      setError({
        errorStatus: true,
        errorMessage: error?.response?.data?.message,
        bgColor: "alert alert-danger",
      });
      setDisable(false)
    }
  }


  const handleClickReportDownload = async () => {
  try {
    const endpoint = `${NODE_HOST_URL_v1}/click_report_download`;

    const payload = {
      user_id: userId,
      token: userToken,
      fromdate: currentDate(startDate),
      todate: currentDate(endDate),
      submit_via: submitVia,
      method:
        submitVia === "api"
          ? "clickreport_download_api_csv"
          : "clickreport_download_camp_csv",
    };

    const response = await Axios.post(endpoint, payload, {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    link.setAttribute("download", "click_report.csv");
    document.body.appendChild(link);
    link.click();

    // Log successful download
    handleUserLog(
      "",
        "download_quick_reply_button",
        " quick_reply_button",
        "Quick reply report downloaded successfully",
        " quick_reply_button",
        "",
      {
        fromdate: payload.fromdate,
        todate: payload.todate,
        submit_via: payload.submit_via,
        method: payload.method
      }
    );

    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {

    console.error(error);

    // Log failed download
    handleUserLog(
      "",
        "download_quick_reply_button_error",
        " quick_reply_button",
        error?.response?.data?.message ||
        "Unable to download click report",
        " quick_reply_button",
      "",
      {
        fromdate: currentDate(startDate),
        todate: currentDate(endDate),
        submit_via: submitVia,
        method:
          submitVia === "api"
            ? "clickreport_download_api_csv"
            : "clickreport_download_camp_csv"
      }
    );

    setError({
      errorStatus: true,
      errorMessage:
        error?.response?.data?.message ||
        "Unable to download click report, please try again later",
      bgColor: "alert alert-danger",
    });
  }
};

const handleRcsClickReportDownload = async () => {
  try {
    const endpoint = `${NODE_HOST_URL_v1}/rcsClickReport`;

    const payload = {
      user_id: userId,
      fromDate: currentDate(startDate),
      toDate: currentDate(endDate),
      method: "downloadReport",
      username: username
    };

    const response = await Axios.post(
      endpoint,
      payload,
      {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }
    );

    const blob = new Blob([response.data], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "click_report.csv");

    document.body.appendChild(link);
    link.click();

    // Log successful download
    handleUserLog(
      "",
      "download_quick_reply_report",
      "quick_click_reply",
      "RCS click report downloaded successfully",
      "quick_click_reply",
      "",
      {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        method: payload.method
      }
    );

    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {

    console.error(error);

    // Log failed download
    handleUserLog(
      "",
       "download_quick_reply_report_error",
      "quick_click_reply",
      error?.response?.data?.message ||
        "Unable to download RCS click report",
      "quick_click_reply",
      "",
      {
        fromDate: currentDate(startDate),
        toDate: currentDate(endDate),
        method: "downloadReport"
      }
    );

    setError({
      errorStatus: true,
      errorMessage:
        error?.response?.data?.message ||
        "Unable to download click report, please try again later",
      bgColor: "alert alert-danger",
    });
  }
};

  // const handleRcsClickReportDownload = async () => {
  //   try {
  //     const endpoint = `${NODE_HOST_URL_v1}/rcsClickReport`;

  //     const payload = {
  //       user_id: userId,
  //       fromDate: currentDate(startDate),
  //       toDate: currentDate(endDate),
  //       method: "DownloadRcsReport",
  //     };

  //     const response = await Axios.post(endpoint, payload, {
  //       responseType: "arraybuffer", // expect binary file
  //       headers: {
  //         Authorization: `Bearer ${userToken}`, // <-- add token here
  //       },
  //     });

  //     const blob = new Blob([response.data], {
  //       type: "text/csv;charset=utf-8;", // assuming CSV, adjust if needed
  //     });

  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "click_report.csv"); // set proper filename
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error(error);
  //     setError({
  //       errorStatus: true,
  //       errorMessage:
  //         error?.response?.data?.message ||
  //         "Unable to download click report, please try again later",
  //       bgColor: "alert alert-danger",
  //     });
  //   }
  // };

  const handleSubmitVia = (e) => {
    setSubmitVia(e.target.value)
    setError({ errorStatus: false })
    setUrlDataReport([]);
  }

  const Pagination = () => {
    if (totalPages <= 1 || channel !== "rcs") return null;

    const getPageNumbers = () => {
      const pages = [];
      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) pages.push(i);
      } else {
        if (currentPage <= 3) {
          pages.push(1, 2, 3, 4, "...", totalPages);
        } else if (currentPage >= totalPages - 2) {
          pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
        } else {
          pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
        }
      }
      return pages;
    };

    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <small className="text-muted">
          Page {currentPage} of {totalPages} ({totalRecords} total records)
        </small>
        <nav>
          <ul className="pagination pagination-sm mb-0">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => RcsCtaReport(currentPage - 1)}
                disabled={currentPage === 1 || disable} // ✅ also disable during loading
              >
                &laquo; Prev
              </button>
            </li>

            {getPageNumbers().map((page, index) =>
              page === "..." ? (
                <li key={`ellipsis-${index}`} className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              ) : (
                <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => RcsCtaReport(page)}
                    disabled={currentPage === page || disable} // ✅ also disable during loading
                  >
                    {page}
                  </button>
                </li>
              )
            )}

            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => RcsCtaReport(currentPage + 1)}
                disabled={currentPage === totalPages || disable} // ✅ also disable during loading
              >
                Next &raquo;
              </button>
            </li>
          </ul>
        </nav>
      </div>
    );
  };


  return (
    <div className="wrapper">
      <DashboardLeftMenu />
      <div className="main">
        <DashboardHeader />
        <main className="content">
          <div className="card">
            {isLoading && <Spining />}
            <div className="card-body">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
                <div>
                  <h4 className="mb-1 fw-semibold text-primary">Quick Reply</h4>
                  <div className="text-muted small">Filter by channel and date range to view summary</div>
                </div>
              </div>
              <div className="container-fluid p-0">
                <div className="row">
                  <div className="col-md-12">
                    {
                      error.errorStatus ?
                        <div className={error.bgColor} role="alert">
                          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">×</span>
                          </button>
                          <div className="">
                            {error.errorMessage}
                          </div>
                        </div>
                        :
                        null
                    }
                    <form className="row mb-4 align-items-end">
                      <div className="col-md-3">
                        <label className="form-label">Channel</label>
                        <select
                          className="form-control"
                          name="channel"
                          value={channel}
                          onChange={onChange}
                        >
                          <option value="">Select Channel</option>
                          <option value="whatsapp">Whatsapp</option>
                          <option value="rcs">Rcs</option>
                          <option value="email">Email</option>
                        </select>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">From Date</label>
                        <ReactDatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={startDate}
                          className="form-control"
                          onChange={(date) => setStartDate(date)}
                          selectsStart
                          startDate={startDate}
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">To Date</label>
                        <ReactDatePicker
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          selectsEnd
                        />
                      </div>

                      {channel === "whatsapp" &&
                        <div className="col-md-3">
                          <label className="form-label">Submit Via</label>
                          <select
                            className="form-control"
                            name="channel"
                            value={submitVia}
                            onChange={handleSubmitVia}
                          >
                            <option value="">Select</option>
                            <option value="pannel">Pannel</option>
                            <option value="api">Api</option>
                          </select>
                        </div>}

                      {/* ✅ Search button aligned right */}

                      {channel !== "whatsapp" &&
                        <div className="col-md-3 d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-info px-5"
                            onClick={channel === "rcs" ? () => RcsCtaReport(1) : channel === "whatsapp" ? urlDetails : EmailCtaReport}
                            disabled={disable}
                          >
                            {disable ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Searching...
                              </>
                            ) : (
                              "Search"
                            )}
                          </button>
                        </div>}
                    </form>

                    {channel === "whatsapp" &&
                      <div className="row">
                        <div className="col-6"></div>
                        <div className="col-md-6 d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-info px-5"
                            onClick={channel === "rcs" ? () => RcsCtaReport(1) : channel === "whatsapp" ? urlDetails : channel === "email" ? EmailCtaReport : null}
                            disabled={disable}
                          >
                            {disable ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Searching...
                              </>
                            ) : (
                              "Search"
                            )}
                          </button>
                        </div>
                      </div>}
                  </div>
                </div>

                <div>
                  {urlDataReport.length > 0 ? (
                    <>
                      <div className="row mt-3">
                        <div className='col-6'>
                          {channel === "rcs" &&
                            <div className="input-group float-right">
                              <div className="input-group-prepend">
                                <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                              </div>
                              <input
                                type="text"
                                id="searchInput"
                                name="searchdata"
                                value={searchData}
                                onChange={(e) => setSearchData(e.target.value)}
                                className="form-control"
                                placeholder="Search"
                              />
                            </div>}
                        </div>
                        <div className="col-6">
                          <button
                            type="button"
                            className="btn btn-warning float-right mb-2"
                            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, height: "45px", color: "white" }}
                            onClick={channel === "whatsapp" ? handleClickReportDownload : handleRcsClickReportDownload}
                          >
                            Download
                          </button>


                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped table-sm">
                          <thead>
                            <tr>
                              {channel === "whatsapp" && (
                                <>
                                  <th>Campaign ID</th>
                                  <th>Phone Number</th>
                                  <th>IP</th>
                                  <th>Main URL</th>
                                  <th>Short URL</th>
                                  <th>Total Click Count</th>
                                  {submitVia === "pannel" && <th>Action</th>}
                                </>
                              )}

                              {channel === "rcs" && (
                                <>
                                  <th>Campaign ID</th>
                                  <th>Campaign Name</th>
                                  <th>Sender ID</th>
                                  <th>Text</th>
                                  <th>Type</th>
                                  <th>Click Count</th>
                                  <th>Created Date</th>
                                  <th>Action</th>
                                </>
                              )}

                              {channel === "email" && (
                                <>
                                  <th>Main URL</th>
                                  <th>Count</th>
                                  {/* <th>Created Date</th> */}
                                  <th>Action</th>
                                </>
                              )}
                            </tr>
                          </thead>

                          <tbody>
                            {urlDataReport.map((item, i) => (
                              <tr key={i}>
                                {/* WHATSAPP */}
                                {channel === "whatsapp" && (
                                  <>
                                    <td>{item._id.camp_id}</td>
                                    <td>{item._id.phone_number}</td>
                                    <td>{item.ip}</td>
                                    <td>{item._id.main_url}</td>
                                    <td>{item._id.short_url}</td>
                                    <td>{item.total_url_click_count}</td>
                                    {submitVia === "pannel" &&
                                      <td>
                                        <a
                                          target="_blank"
                                          href={`/dashboard/quick-reply-summary/${encodeURIComponent(channel)}/${encodeURIComponent(startDate)}/${encodeURIComponent(endDate)}/pannel/${encodeURIComponent("https://console.authkey.io")}/410124050916161419463974`}
                                          style={{ textDecoration: "none" }}
                                        >
                                          <FontAwesomeIcon
                                            style={{ cursor: "pointer", color: "blue" }}
                                            icon={faEye}
                                          />
                                        </a>
                                      </td>}
                                  </>
                                )}

                                {/* RCS */}
                                {channel === "rcs" && (
                                  <>
                                    <td>{item.campaign_id}</td>
                                    <td>{item.campaign_name}</td>
                                    <td>{item.sender_id}</td>
                                    <td>{item.text}</td>
                                    <td>{item.type}</td>
                                    <td className="text-center">{item.clickCount}</td>
                                    <td>{item.created_date}</td>
                                    <td className="text-center">
                                      <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={`/dashboard/quick-reply-summary/${encodeURIComponent(
                                          channel
                                        )}/${encodeURIComponent(startDate)}/${encodeURIComponent(
                                          endDate
                                        )}/pannel/${encodeURIComponent(
                                          "https://console.authkey.io"
                                        )}/${item.context_ids ?? "not_found"}`}
                                        style={{ textDecoration: "none" }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faEye}
                                          style={{ cursor: "pointer", color: "blue" }}
                                        />
                                      </a>
                                    </td>
                                  </>
                                )}

                                {/* EMAIL */}
                                {channel === "email" && (
                                  <>
                                    <td>{item.main_url}</td>
                                    <td className="text-center">{item.count}</td>
                                    {/* <td>
                                      {Array.isArray(item.created)
                                        ? item.created.map((x, index) => (
                                          <div key={index}>{x}</div>
                                        ))
                                        : item.created}
                                    </td> */}
                                    <td className="text-center">
                                      <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={`/dashboard/quick-reply-summary/${encodeURIComponent(
                                          channel
                                        )}/${encodeURIComponent(startDate)}/${encodeURIComponent(
                                          endDate
                                        )}/pannel/${encodeURIComponent(
                                          item.main_url
                                        ) || null}/410124050916161419463974`}
                                        style={{ textDecoration: "none" }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faEye}
                                          style={{ cursor: "pointer", color: "blue" }}
                                        />
                                      </a>
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <Pagination />

                    </>
                  ) :
                    //   urlDataReport.length > 0 && submitVia === "api" ? (
                    //     <div className="table-responsive">
                    //       <table className="table table-striped table-sm">
                    //         <thead>
                    //           <tr>
                    //             <th>Date</th>
                    //             <th>Total Count</th>
                    //           </tr>
                    //         </thead>
                    //         <tbody>
                    //           {urlDataReport.map((item, i) => (
                    //             <tr key={i}>
                    //               <td>{item.date}</td>
                    //               <td>{item.total_count}</td>
                    //             </tr>
                    //           ))}
                    //         </tbody>
                    //       </table>
                    //     </div>) : 
                    (
                      <div className="text-center">
                        <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                        <p>Data Not Found</p>
                      </div>
                    )
                  }



                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default QuickReply;
